import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ProductSearchResults",
    component: () =>
        __SERVER__ ? require("./product-search-results-view") : import("./product-search-results-view")
});

export default definition;
